import Vue from "vue";
import App from "./App.vue";
import JsonExcel from "vue-json-excel";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import VueMask from "v-mask";
import * as VueGoogleMaps from "vue2-google-maps";
import VueYoutube from "vue-youtube";
import { authHeader } from "./helpers/auth/auth-header";
import { TabPlugin } from "@syncfusion/ej2-vue-navigations";
import Vuex from "vuex";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "element-ui/lib/theme-chalk/index.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
import CKEditor from "@ckeditor/ckeditor5-vue";

Vue.use(CKEditor);
Vue.use(Vuex);
Vue.use(TabPlugin);
Vue.use(ElementUI, { locale });
Vue.use(Multiselect);
import vco from "v-click-outside";

import router from "./router";
import store from "@/state/store";
// import i18n from "./i18n";

import axios from "axios";
axios.defaults.headers = authHeader();
Vue.prototype.$http = axios;

import "@/assets/scss/app.scss";

require("dotenv").config();

Vue.config.productionTip = false;
Vue.use(VueYoutube);
Vue.use(BootstrapVue);
Vue.use(vco);
Vue.component("downloadExcel", JsonExcel);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
    libraries: "places",
  },
  installComponents: true,
});
Vue.component("apexchart", VueApexCharts);

new Vue({
  data: { loading: false },
  router,
  store,
  // i18n,
  render: (h) => h(App),
}).$mount("#app");
